import {cardSvg as Icon__small__cardSvg} from '../Icon__small/Icon__small--card.js';

export var card = {
  name: 'card',
  category: 'icon',
  colorable: true,
  svg: Icon__small__cardSvg,
};
